import { type LucideProps, Share, Share2 } from 'lucide-react';

import { isAndroid } from '@/utils/platform';

/**
 * Platform-native "share" glyph.
 *
 * iOS (and desktop / unknown platforms) use the box-with-up-arrow
 * (`Share`) — the familiar iOS share-sheet affordance. Android uses the
 * Material connected-nodes glyph (`Share2`). Matching each OS's own
 * share icon makes the button read as native rather than generic.
 *
 * Forwards all `LucideProps`, so it drops in wherever a lucide icon was
 * used: `<ShareIcon className="w-4 h-4 mr-1.5" />`.
 */
export function ShareIcon(props: LucideProps) {
  const Glyph = isAndroid() ? Share2 : Share;
  return <Glyph {...props} />;
}
